//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        rows: {
            type: Number,
            default: 4,
        },
        minlength: {
            type: Number,
            default: null,
        },
        maxlength: {
            type: Number,
            default: null,
        },
        autogrow: {
            type: Boolean,
            default: false,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        error: {
            type: [Boolean, String],
            default: false,
        },
        success: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        isClient: {
            type: Boolean,
            default: false,
        },
        margins: {
            type: Boolean,
            default: true,
        },
        value: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            inputText: '',
        };
    },
    computed: {
        /** @return {boolean} */
        showMaxLength() {
            return Boolean(this.maxlength && !this.minlength);
        },
        /** @return {number} */
        length() {
            return this.inputText.length;
        },
        /** @return {boolean} */
        hasLabel() {
            return !!this.error || !!this.label;
        },
        /** @return {boolean} */
        hasError() {
            return !!(typeof(this.error) === 'string' && this.error.length);
        },
    },
    watch: {
        /** @type {Vue.WatchHandler<string>} */
        value(value) {
            this.inputText = value;
        },
    },
    created() {
        this.inputText = this.value;
    },
    methods: {
        /** @param {Event} e */
        input(e) {
            const target = /** @type {HTMLTextAreaElement} */(e.target);
            const value = target.value;
            this.inputText = value;
            this.$emit('input', value);
        },
    },
};
